import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="policy-page returns">
      <header>
        <p className="eyebrow">Customer care</p>
        <h1>Returns &amp; exchanges</h1>
        <p>
          We hope every piece feels right. If it does not, eligible items can be
          returned within {siteConfig.commerce.returnsWindowDays} days of delivery.
        </p>
      </header>
      <section className="policy-accordions">
        <details open>
          <summary>Start a return</summary>
          <ol>
            <li>Contact client service with your order number and the pieces you wish to return.</li>
            <li>We will reply with the return address and packing guidance.</li>
            <li>Place unworn items in their original packaging and send them with tracking.</li>
          </ol>
        </details>
        <details>
          <summary>Return conditions</summary>
          <p>
            Items must be unworn, unwashed and unaltered, with original tags
            attached. Shoes and delicate pieces should be returned with all
            protective packaging. For hygiene reasons, marked intimate items
            cannot be returned.
          </p>
        </details>
        <details>
          <summary>Refunds</summary>
          <p>
            Approved refunds are issued to the original payment method within
            5–10 business days after inspection. Original delivery costs and
            return postage are not refundable unless an item was faulty.
          </p>
        </details>
        <details>
          <summary>Exchanges</summary>
          <p>
            To secure another size or colour quickly, return the original piece
            and place a new order. Our team can assist with availability before
            you send your return.
          </p>
        </details>
      </section>
      <div className="policy-contact">
        <h2>Ready to begin?</h2>
        <p>Please include your order number so we can help without delay.</p>
        <Link className="solid-button" to="/contact">Request a return</Link>
      </div>
    </main>
  );
}

export default Returns;
